import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import { FlatList, StyleSheet } from 'react-native';
import { format as formatDate } from 'date-fns';
import { theme } from '@xbto/design-system';
import { API } from '@xbto/api-client';
import { Col, Row, TextBody } from '../../atoms';
import { Tag } from '../../molecules';
import { AmountQuantity } from '../amount-quantity';
export function ActivityList({ data }) {
    // Handlers
    const handlerRenderItem = useCallback(({ item: activity }) => {
        const title = activity.activityLabel === API.ActivityLabel.FundRedemption
            ? 'Redeemed'
            : activity.activityLabel === API.ActivityLabel.FundSubscription
                ? 'Subscribed'
                : activity.activityLabel;
        const amount = !activity.currency1 || !activity.currency1.code ? null : (_jsx(AmountQuantity, { value: activity.amount1, currencyCode: activity.currency1.code, color: "primary", em: true }));
        return (_jsxs(Col, { style: $.item, children: [_jsxs(TextBody, { em: true, lhFull: true, children: [title, " ", amount] }), _jsxs(Row.LR, { mt: "4", children: [_jsx(TextBody, { small: true, lhFull: true, children: formatDate(activity.creationDate, 'dd/MM/yyyy HH:mm') }), _jsx(Tag, { label: "Completed", variant: "success", large: true })] })] }));
    }, []);
    // Render
    return (_jsx(FlatList, { style: $.container, contentContainerStyle: $.content, data: data, renderItem: handlerRenderItem }));
}
const $ = StyleSheet.create({
    container: {
        marginHorizontal: -theme.spacing['4'],
    },
    item: {
        padding: theme.spacing['4'],
        borderTopWidth: 1,
        borderTopColor: theme.color.border.primary,
    },
    content: {
        borderBottomWidth: 1,
        borderBottomColor: theme.color.border.primary,
    },
});
